import styled from 'styled-components';

export const CircleWrapper = styled.div`
	position: absolute;
	top: -1000px;
`;
